export const scrollWithoffset = (e: HTMLElement) => {                                            //Ajuste de offset con el link de contacto
    const navBar = document.querySelector(".contMenu") as HTMLDivElement;
    const altoNavBar = navBar.offsetHeight;
    const ypos = e.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({top: ypos - altoNavBar, behavior: "smooth"});
};
